// Sprite-based logo lookup. The sprite is now embedded inline at app
// root by <SpriteInline />, so we use same-document fragment refs
// (`#gemini`) instead of cross-document URLs. Telegram's WebKit-based
// clients don't resolve `<linearGradient>` references inside externally
// referenced symbols, the inline sprite sidesteps that bug.

export const LOGO_ID_BY_LABEL: Record<string, string> = {
  // anthropic family
  "Opus 4.7":       "anthropic",
  "Sonnet 4.6":     "anthropic",
  "Claude Haiku":   "anthropic",
  // google
  "Gemini 3.1 Pro": "gemini",
  // openai
  "GPT-5.5":        "openai",
  "GPT-5.4":        "openai",
  // xai
  "Grok 4.3":       "xai",
  // moonshot
  "Kimi K2.6":      "kimi",
  // deepseek
  "DeepSeek V4":    "deepseek",
  // glm
  "GLM 5.1":        "glm",
};

export function spriteHrefFor(label: string): string | undefined {
  const id = LOGO_ID_BY_LABEL[label];
  return id ? `#${id}` : undefined;
}
